export default {
  delContent: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000732","确定要删除该仓库信息吗？") /* "确定要删除该仓库信息吗？" */,
  rejectContent: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000733","该仓库已被使用，不能删除") /* "该仓库已被使用，不能删除" */
};
